<template>
  <div class="recordsContainer">
    <RecordItem
      v-for="item in joinedRecords"
      :key="item.id"
      :data="item"
      :timeStr="`助力时间：${timeStr(item)}`"
      @clickGoActHome="handleClickGoActHome"
      @clickGoAwards="handleClickGoAwards"
    />
    <div class="empty" v-if="joinedRecords.length === 0">
      <div class="emptyIcon"></div>
      <div class="note">您还没有参与任何活动哦～</div>
    </div>
    <div class="noMore" v-if="joinedRecords.length">
      没有更多了~
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import RecordItem from './RecordItem';
import { toDayDate } from '@/components/templates/helper';
export default {
  components: { RecordItem },
  computed: {
    ...mapState('app/inviteEarnCoupon/playHistory', {
      joinedRecords: 'joinedRecords'
    })
  },
  methods: {
    timeStr(data) {
      return toDayDate(data.startTime, 'yyyy.MM.dd hh:mm');
    },
    handleClickGoActHome() {
      this.$emit('reportEvent', {
        event: 'invite_boost_coupon_activity_click',
        module_name: '我参与的',
        button_name: '查看活动'
      });
    },
    handleClickGoAwards() {
      this.$emit('reportEvent', {
        event: 'invite_boost_coupon_activity_click',
        module_name: '我参与的',
        button_name: '查看奖品'
      });
    }
  }
};
</script>

<style lang="less" scoped>
.recordsContainer {
  .fcc;
  padding-top: 38px;

  .noMore {
    margin: 30px 0;
    text-align: center;
  }
}
.empty {
  margin: 300px;
  text-align: center;
  .fcc;

  .emptyIcon {
    width: 392px;
    height: 254px;
    background: center / cover no-repeat url('../../assets/images/empty.png');
  }

  .note {
    margin-top: 30px;
    color: #8c8c8c;
    font-size: 30px;
  }
}
</style>
